export default class DirectSubscriptionInput {
	constructor( 
        public ProviderId: string,
        public SubscriberUri: string,
        public CIID: string
    ) { }
}